module.exports = __webpack_public_path__ + "img/style_2_en.c276d303.jpeg";